import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { BrowserRouter as Router } from 'react-router-dom';
import './Styles/Toyota.scss'
import AppVars from './AppVars.js';
import Logger from './Logger.js';

const appVars = AppVars.getInstance();
appVars.setEnv();
const env = appVars.getEnv();
appVars.setData(env);

const logger = Logger.getInstance();
logger.setEnv();

// === Adobe Analytics Setup (Queue + Environment) ===
const taggingEnv = env === 'prod' ? 'prod' : 'pre-prod';
window.__analytics_queue__ = window.__analytics_queue__ || [];
document.documentElement.setAttribute('data-env-name', taggingEnv);

const isMobile = window.innerWidth <= 825;
const breakpoint = window.innerWidth <= 825 ? 'sm' : 'lg';

window._dL = {
  propertyCode: 'toyota',
  brand: 'Toyota',
  language: 'en',
  environment: taggingEnv,
  pageLoadTimestamp: Date.now(),
  appVersion: '1.0.0',
  device_type: isMobile ? 'mobile' : 'desktop',
  breakpoint: breakpoint,
  app: 'tcom sign in',
  content_section: 'Sign in Landing Page'
};

window.addEventListener('resize', () => {
  const isMobile = window.innerWidth <= 825;
  window._dL.device_type = isMobile ? 'mobile' : 'desktop';
  window._dL.breakpoint = isMobile ? 'sm' : 'lg';
});

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <Router>
      <App />
    </Router>
  </React.StrictMode>
);
// Optional: Enable service worker
serviceWorker.unregister(); // Or serviceWorker.register() if you want PWA capabilities